module.exports = __webpack_public_path__ + "img/icon-power-btn-red.f08c212a.svg";